// extracted by mini-css-extract-plugin
module.exports = {"headerCorporate":"HeaderCorporate_headerCorporate__5ETww","layout":"HeaderCorporate_layout__G_8Uj","emptySquare":"HeaderCorporate_emptySquare__8fikI"};